import { Component, Input, OnInit } from '@angular/core';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { PaymentStatusEnum } from '@app/core/services/transaction/model/enum/payment-status.enum';
import { Transaction } from '@app/core/services/transaction/model/transaction.model';
import { UtilService } from '@app/core/services/util/util.service';

@Component({
  selector: 'ap-transaction-details-attempts',
  templateUrl: './transaction-details-attempts.component.html',
  styleUrl: './transaction-details-attempts.component.css',
  standalone: false
})
export class TransactionDetailsAttemptsComponent implements OnInit {

  @Input() transaction: Transaction;
  @Input() userView = false;

  Permissions = PermissionEnum;
  PaymentStatus = PaymentStatusEnum;

  paymentAttemptColumns = ['NUMBER', 'MODIFICATION_DATE', 'STATUS', 'STATUS_DETAILS', 'TRANSACTION_ID'];

  constructor(private utilService: UtilService) {}

  ngOnInit(): void {
    if (this.transaction?.attempts && this.transaction?.attempts.length > 0) {
      this.transaction.attempts = this.transaction.attempts.sort((a,b) => this.utilService.compare(a.sequenceOrder, b.sequenceOrder, false));
    }
  }

}
